import { IconButton, Tooltip } from '@mui/material'
import ProductsIcon from 'icons/ProductsIcon';
import { useHref } from 'react-router-dom';
import { colors } from 'styles/colors';

interface Props {
  path: string;
}

// Opens in a new tab, the way the view button beside it does.
export default function ProductsActionButton({ path }: Props) {
  const href = useHref(path);

  const handlePress = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    window.open(href, '_blank', 'noopener,noreferrer');
  };

  return (
    <Tooltip title={'Products'}>
      <IconButton
        component="a"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handlePress}
        sx={{
          width: 25,
          height: 25,
          backgroundColor: colors.lightPurple,
          borderRadius: '4px',
          padding: 0,
          '&:hover': {
            backgroundColor: colors.lightPurple,
          },
        }}
      >
        <ProductsIcon size={14} color='white' />
      </IconButton>
    </Tooltip>
  )
}
